// extracted by mini-css-extract-plugin
export default {"courses":"OurCourse_courses__MBvqI","course_box":"OurCourse_course_box__NArJ6","our_courses":"OurCourse_our_courses__hE6o7"};